import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import { Toaster } from "react-hot-toast";

import setAuthToken from "./utils/api/token";

import NotFound from "./views/errors/404";
import PublicRoutes from "./routing/routes";
import SecureRoutes from "./routing/secure";
import Tokenize from "./views/tokenize";
import MarketingRedirect from "./views/marketing-redirect";
import GenericSurvey from "./views/generic-survey";

import { get as getUser, logout } from "./actions/auth";

const App = ({ getUser, logout }) => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    let mounted = true;

    const hydrate = async () => {
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
          await getUser();
        }
      } finally {
        if (mounted) setHydrated(true);
      }
    };

    const handleStorage = async () => {
      if (!localStorage.token || !localStorage.instance) {
        await logout();
      }
    };

    hydrate();

    window.addEventListener("storage", handleStorage);
    return () => {
      mounted = false;
      window.removeEventListener("storage", handleStorage);
    };
  }, [getUser, logout]);

  return (
    <BrowserRouter>
      <Toaster position="bottom-right" reverseOrder={false} />
      {hydrated && (
        <Routes>
          <Route path="/" element={<MarketingRedirect />} />
          <Route path="/authentic/tokenize" element={<Tokenize />} />
          <Route path="/tokenize" element={<Tokenize />} />
          <Route path="/public/*" element={<PublicRoutes />} />
          <Route path="/s/:publicKey" element={<GenericSurvey />} />
          <Route path="/embed/:publicKey" element={<GenericSurvey embedded />} />
          <Route path="/dashboard/*" element={<SecureRoutes />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default connect(null, { getUser, logout })(App);
